var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharpOutlineNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6316 2H13.6316V4.2358C16.1504 4.90254 17.9961 7.07098 17.9961 9.6431V17.0074V17.0248H19H20V19.0248H19H5H4V17.0248H5H5.99609V17.0074V9.6431C5.99609 6.97958 7.97528 4.74895 10.6316 4.17047V2ZM15.9961 9.6431V17.0074H7.99609V9.6431C7.99609 7.76633 9.66118 6.02454 11.9961 6.02454C14.331 6.02454 15.9961 7.76633 15.9961 9.6431ZM14.1307 20.0062H10.1316V22H14.1307V20.0062Z",
    fill: "#0F172A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharpOutlineNotification);
export default __webpack_public_path__ + "static/media/sharp--outline--notification.7824f2674612ef172520c54de042047d.svg";
export { ForwardRef as ReactComponent };